import { FC, HTMLAttributes } from 'react';
import { useSnapshot } from 'reactish-state';
import { ReturnToPlayer as ReturnToPlayerComponent } from '../../components/ReturnToPlayer';
import { store } from '../../stores';

export const ReturnToPlayer: FC<HTMLAttributes<HTMLDivElement>> = (props) => {
    const { returnToPlayer, isPayTableOpen, denominationIndex } =
        useSnapshot(store);

    if (!returnToPlayer || !isPayTableOpen) {
        return null;
    }

    return (
        <ReturnToPlayerComponent
            {...props}
            returnToPlayerValue={returnToPlayer[denominationIndex]}
        />
    );
};
